import { Create } from "react-admin";
import { JobApplicationClosureReasonForm } from "./index";

export const JobApplicationClosureReasonCreate = () => (
  <Create>
    <JobApplicationClosureReasonForm />
  </Create>
);
